export class LoginResponse {
    public token: string
    public requireTfa: boolean
}
